import { createFileRoute } from "@tanstack/react-router";
import AdminTeammateDetail from "@/pages/AdminTeammateDetail";

export const Route = createFileRoute("/admin/teammate-linkage/$teammateId/")({
  component: AdminTeammateDetail,
});
